export const DrawerManager = (() => {
    const drawers = {};
    let activeDrawer = null;

    const openDrawer = (drawerId) => {
        const drawer = document.getElementById(drawerId);
        if (!drawer) return;

        const overlay = drawer.querySelector('.rem-drawer-overlay');
        const content = drawer.querySelector('.rem-drawer-content');

        document.body.classList.add('overflow-hidden');
        drawer.classList.remove('invisible', 'hidden');
        activeDrawer = drawer;

        // Contenido
        if (content) {
            setTimeout(() => { content.classList.add('translate-x-0'); }, 10);
        }

        // Overlay
        if (overlay) {
            setTimeout(() => { overlay.classList.add('opacity-100'); }, 10);

            // Cerrar drawer al hacer clic en el fondo, pero sólo si no está bloqueado
            if (!drawer.dataset.locked) {
                overlay.addEventListener('click', handleOverlayClick);
            }
        }

        // Añadir eventos para cerrar drawer
        drawer.querySelectorAll('[data-drawer-close]').forEach(btn => {
            btn.addEventListener('click', () => closeDrawer(drawerId));
        });

        // Añadir evento para cerrar drawer con la tecla "Escape"
        document.addEventListener('keydown', handleEscapeKey);

        return {
            drawer,
            lock: () => lockDrawer(drawerId),
        };
    };

    const closeDrawer = (drawerId) => {
        const drawer = document.getElementById(drawerId);
        if (!drawer) return;

        const overlay = drawer.querySelector('.rem-drawer-overlay');
        const content = drawer.querySelector('.rem-drawer-content');

        setTimeout(() => {
            document.body.classList.remove('overflow-hidden');
            drawer.classList.add('invisible', 'hidden');
        }, 300);

        // Contenido
        if (content) {
            content.classList.remove('translate-x-0');
        }

        // Overlay
        if (overlay) {
            overlay.classList.remove('opacity-100');

            // Remover listener del overlay cuando se cierra el drawer
            overlay.removeEventListener('click', handleOverlayClick);
        }

        // Si se está cerrando el drawer activo, actualizar el estado
        if (activeDrawer === drawer) {
            activeDrawer = null;

            // Si hay otro drawer abierto, reasignar el event listener
            const remainingDrawers = Object.values(drawers).filter(drawer => !drawer.classList.contains('hidden'));
            if (remainingDrawers.length > 0) {
                activeDrawer = remainingDrawers[remainingDrawers.length - 1];
            } else {
                document.removeEventListener('keydown', handleEscapeKey);
            }
        }
    };

    const handleEscapeKey = (event) => {
        if (event.key === 'Escape' && activeDrawer && !activeDrawer.dataset.locked) {
            closeDrawer(activeDrawer.id);
        }
    };

    const handleOverlayClick = () => {
        if (activeDrawer && !activeDrawer.dataset.locked) {
            closeDrawer(activeDrawer.id);
        }
    };

    const lockDrawer = (drawerId) => {
        const drawer = document.getElementById(drawerId);
        if (drawer) {
            drawer.dataset.locked = 'true';
            drawer.querySelector('.rem-drawer-close-btn')?.classList.add('hidden');

            const overlay = drawer.querySelector('.rem-drawer-overlay');
            if (overlay) {
                overlay.removeEventListener('click', handleOverlayClick);
            }
        }
        return {
            drawer,
            open: () => openDrawer(drawerId),
        };
    };

    const unlockDrawer = (drawerId) => {
        const drawer = document.getElementById(drawerId);
        if (drawer) {
            delete drawer.dataset.locked;
            drawer.querySelector('.rem-drawer-close-btn')?.classList.remove('hidden');

            const overlay = drawer.querySelector('.rem-drawer-overlay');
            if (overlay) {
                overlay.addEventListener('click', handleOverlayClick);
            }
        }
    };

    const attachOpenDrawerButton = (buttonId, drawerId) => {
        const button = document.getElementById(buttonId);
        if (button) {
            button.addEventListener('click', () => openDrawer(drawerId));
        }
    };

    return {
        openDrawer,
        closeDrawer,
        lockDrawer,
        unlockDrawer,
        attachOpenDrawerButton
    };
})();